import timePicker from "../time-picker";

const commonTimePicker = {
  install: function (Vue) {
    Vue.component("commonTimePicker", timePicker);
  },
};

// 导出该组件

export default commonTimePicker;
